/* global analytics  */
import { useEffect, useState } from 'react'

export default function usePathnameTracking() {
  const [firstTime, setFirstTime] = useState(true)

  // since we're also tracking the pageview on the first render using _segmentio_integration.html.slim, we need to prevent from tracking twice on load
  useEffect(() => {
    setFirstTime(false)
  }, [])

  // I wasn't able to use React Router's location for two reasons:
  // 1) if location was the dependency, this useEffect would be triggered on every query parameter change
  // 2) the location is not always the complete path, because it will depend on React Router's basename
  useEffect(() => {
    if (firstTime) return
    analytics.page(window.location.pathname)
  }, [window.location.pathname])
}
